export const createSingleFlight = <K, T>() => {
    let inFlight: { key: K; promise: Promise<T> } | null = null

    return (key: K, run: () => Promise<T>): Promise<T> => {
        if (inFlight && inFlight.key === key) {
            return inFlight.promise
        }
        const promise = run()
        const entry = { key, promise }
        inFlight = entry
        const clear = () => {
            if (inFlight === entry) {
                inFlight = null
            }
        }
        promise.then(clear, clear)
        return promise
    }
}
